var H = require("hogan.js");
window.gettext || require("ehogan-loader/gt.js");
window.jscAdd || require("ehogan-loader/jscmanager.js");
module.exports = function() { var T = new H.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b(t.v( gettext("Сервер временно недоступен. Повторите попытку позже.") ));t.b("\n");return t.fl(); },partials: {}, subs: {  }}, "{{ ___0___ }}\n", H);return T[arguments[0] instanceof Array ? "ri" : "render"].apply(T, arguments); };


//////////////////
// WEBPACK FOOTER
// ./static-source/messages/server_temporarily_unavailable.html
// module id = 210
// module chunks = 4